import { GettingEndpoint, PostingEndpoint } from '@/domain/services/Api/Endpoint';
import { RoutesGetter, useRoutesDao } from '@/domain/dao/Routes';

const routes = useRoutesDao<{
	file: {
		selectThumbnail: (p: { token: string }) => string;
		availableThumbnails: (p: { token: string }) => string;
	};
}>();

const useApi = (token: string) => ({
	selectThumbnail: (thumbnail: string) =>
		PostingEndpoint<{ thumbnail: string }, void>(routes.file.selectThumbnail as RoutesGetter)({ token })({ thumbnail }),
	availableThumbnails: () => GettingEndpoint<string[]>(routes.file.availableThumbnails as RoutesGetter)({ token }),
});

export { useApi };
